import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  ButtonComponent,
  ButtonColor,
  ButtonSize,
} from '@freelancer/ui/button';
import { CardComponent } from '@freelancer/ui/card';
import {
  IconModule,
  IconBackdrop,
  IconBackdropSize,
  IconBackdropStyle,
  IconColor,
  IconSize,
} from '@freelancer/ui/icon';

@Component({
  standalone: true,
  selector: 'fl-widget',
  imports: [ButtonComponent, CardComponent, IconModule],
  template: `
    <fl-card class="mb-small">
      <div class="Header mb-small">
        <fl-icon
          class="mr-xxsmall"
          [backdrop]="iconBackdrop"
          [backdropStyle]="IconBackdropStyle.TRANSPARENT"
          [backdropSize]="IconBackdropSize.XXXSMALL"
          [color]="iconColor"
          [name]="iconName"
          [size]="IconSize.SMALL"
        ></fl-icon>
        <p
          class="text-small font-medium"
          i18n="Widget title"
        >
          {{ titleText }}
        </p>
      </div>
      <p class="mb-small">
        <ng-content></ng-content>
      </p>
      <fl-button
        i18n="Widget Button"
        [display]="'block'"
        [color]="ButtonColor.DEFAULT"
        [size]="ButtonSize.SMALL"
        [busy]="busy"
        (click)="handleButtonClick()"
      >
        {{ buttonText }}
        <ng-content select="fl-widget-button"></ng-content>
      </fl-button>
    </fl-card>
  `,
  styleUrls: ['./widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetComponent {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  IconBackdropSize = IconBackdropSize;
  IconBackdropStyle = IconBackdropStyle;
  IconSize = IconSize;

  @Input() iconBackdrop: IconBackdrop;
  @Input() iconColor: IconColor;
  @Input() titleText: string;
  @Input() buttonText: string;
  @Input() height: string;
  @Input() width: string;
  @Input() iconName: string;
  @Input() busy: boolean;
  @Output() buttonClick = new EventEmitter<void>();

  handleButtonClick(): void {
    this.buttonClick.emit();
  }
}
